//상품 정보고시 불러오기
export const MenuInfoText = [
  {name: "의류", idx: 'info1'},
  {name: "구두/신발", idx: 'info2'},
  {name: "가방", idx: 'info3'},
  {name: "패션잡화(모자/벨트/액세서리 등)", idx: 'info4'},
  {name: "침구류/커튼", idx: 'info5'},
  {name: "가구(침대/소파/싱크대/DIY제품 등)", idx: 'info6'},
  {name: "영산가전(TV류)", idx: 'info7'},
  {name: "가정용 전기제품(냉장고/세탁기/식기세척기/전자레인지 등)", idx: 'info8'},
  {name: "계절가전(에어컨/온풍기 등)", idx: 'info9'},
  {name: "사무용기기(컴퓨터/노트북/프린터 등)", idx: 'info10'},
  {name: "광학기기(디지털카메라/캠코더 등)", idx: 'info11'},
  {name: "소형전자(MP3/전자사전 등)", idx: 'info12'},
  {name: "휴대형 통신기기(휴대폰/태블릿 등)", idx: 'info13'},
  {name: "내비게이션", idx: 'info14'},
  {name: "자동차용품(자동차부품/기타 자동차용품 등)", idx: 'info15'},
  {name: "의료기기", idx: 'info16'},
  {name: "주방용품", idx: 'info17'},
  {name: "화장품", idx: 'info18'},
  {name: "귀금속/보석", idx: 'info19_1'},
  {name: "시계류", idx: 'info19_2'},
  {name: "농수산물", idx: 'info20_1'},
  {name: "축산물", idx: 'info20_2'},
  {name: "가공식품", idx: 'info21'},
  {name: "건강기능식품", idx: 'info22'},
  {name: "어린이제품", idx: 'info23'},
  {name: "악기", idx: 'info24'},
  {name: "스포츠용품", idx: 'info25'},
  {name: "서적", idx: 'info26'},
  {name: "호텔/펜션 예약", idx: 'info27'},
  {name: "여행패키지", idx: 'info28'},
  {name: "항공권", idx: 'info29'},
  {name: "자동차 대여 서비스(렌터카)", idx: 'info30'},
  {name: "물품대여 서비스(정수기, 비데, 공기청정기 등)", idx: 'info31'},
  {name: "물품대여 서비스(서적, 유아용품, 행사용품 등)", idx: 'info32'},
  {name: "디지털 콘텐츠(음원, 게임, 인터넷강의 등)", idx: 'info33'},
  {name: "상품권/쿠폰", idx: 'info34'},
  {name: "모바일 쿠폰", idx: 'info35'},
  {name: "영화·공연", idx: 'info36'},
  {name: "생활화학제품", idx: 'info37'},
  {name: "살생물제품", idx: 'info38'},
  {name: "기타 용역", idx: 'info39'},
  {name: "기타 재화", idx: 'info40'},
]

export function MenuInfoList(type) {
  let info1 = [//의류
    '제품 소재', '색상', '치수', '제조자 및 수입자',
    '제조국', '세탁방법 및 취급 주의사항', '제조연월', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info2 = [//구두/신발
    '제품 주소재', '색상', '치수', '제조자 및 수입자', '제조국',
    '취급 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info3 = [//가방
    '종류', '소재', '색상', '크기', '제조자 및 수입자', '제조국',
    '취급 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info4 = [//패션잡화(모자/벨트/액세서리 등)
    '종류', '소재', '치수', '제조자 및 수입자', '제조국',
    '취급 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info5 = [//침구류/커튼
    '제품 소재', '색상', '치수', '제품구성', '제조자 및 수입자', '제조국',
    '세탁방법 및 취급 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info6 = [//가구(침대/소파/싱크대/DIY제품 등)
    '품명', 'KC 인증정보', '색상', '구성품', '주요 소재', '제조자 및 수입자', '제조국',
    '크기', '재공급 사유 및 하자', '배송 및 설치비용', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info7 = [//영산가전(TV류)
    '품명 및 모델명', 'KC 인증정보', '정격전압 및 소비전력', '에너지소비효율등급',
    '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기', '화면사양(크기, 해상도, 비율 등)', '추가설치비용', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info8 = [//가정용 전기제품(냉장고/세탁기/식기세척기/전자레인지 등)
    '품명 및 모델명', 'KC 인증정보', '정격전압 및 소비전력', '에너지소비효율등급',
    '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 용량, 형태', '추가설치비용', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info9 = [//계절가전(에어컨/온풍기 등)
    '품명 및 모델명', 'KC 인증정보', '정격전압 및 소비전력', '에너지소비효율등급',
    '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 형태', '냉난방면적', '추가설치비용', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info10 = [//사무용기기(컴퓨터/노트북/프린터 등)
    '품명 및 모델명', 'KC 인증정보', '정격전압 및 소비전력', '에너지소비효율등급',
    '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 무게', '주요 사양', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info11 = [//광학기기(디지털카메라/캠코더 등)
    '품명 및 모델명', 'KC 인증정보', '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 무게', '주요 사양', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info12 = [//소형전자(MP3/전자사전 등)
    '품명 및 모델명', 'KC 인증정보', '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 무게', '주요 사양', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info13 = [//휴대형 통신기기(휴대폰/태블릿 등)
    '품명 및 모델명', 'KC 인증정보', '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기, 무게', '이동통신 가입조건', '주요 사양', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info14 = [//내비게이션
    '품명 및 모델명', 'KC 인증정보', '정격전압 및 소비전력', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '크기, 무게', '주요 사양',
    '맵 업데이트 비용 및 무상기간', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info15 = [//자동차용품(자동차부품/기타 자동차용품 등)
    '품명 및 모델명', 'KC 인증정보', '동일모델의 출시년월', '제조자 및 수입자', '제조국',
    '크기', '적용 차종', '취급 주의사항', '품질 보증기준', '검사합격증 번호', 'A/S 책임자&전화번호'
  ]
  let info16 = [//의료기기
    '품명 및 모델명', '허가·인증·신고번호', '정격전압 및 소비전력', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '제품 사용목적 및 사용방법',
    '취급 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info17 = [//주방용품
    '품명 및 모델명', '재질', '구성품', '크기', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info18 = [//화장품
    '용량 또는 중량', '제품 주요 사항(피부타입, 색상 등)', '사용기간 또는 개봉 후 사용기간',
    '사용방법', '제조업자 및 판매업자', '제조국', '화장품 성분',
    '사용 주의사항', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info19_1 = [//귀금속/보석
    '소재/순도/밴드재질', '중량', '제조자 및 수입자', '제조국', '치수',
    '착용시 주의사항', '등급', '보증서 제공 여부', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info19_2 = [//시계류
    '소재/순도/밴드재질', '중량', '제조자 및 수입자', '제조국', '치수',
    '착용시 주의사항', '기능', '방수 유무', '보증서 제공 여부', '품질 보증기준', 'A/S 책임자&전화번호'
  ]
  let info20_1 = [//농수산물
    '품목 또는 명칭', '포장단위별 용량(중량), 수량, 크기', '생산자 및 수입자', '원산지',
    '제조연월일, 소비기간 또는 품질유지기간', '유전자변형농수산물여부', '상품구정',
    '보관방법 및 취급방법', '안전 주의사항', 'A/S 책임자&전화번호'
  ]
  let info20_2 = [//축산물
    '품목 또는 명칭', '포장단위별 용량(중량), 수량, 크기', '생산자 및 수입자', '원산지',
    '제조연월일, 소비기간 또는 품질유지기간', '등급', '이력관리대상축산물 유무', '상품구정',
    '보관방법 및 취급방법', '안전 주의사항', 'A/S 책임자&전화번호'
  ]
  let info21 = [//가공식품
    '제품명', '식품 유형', '제조업체 및 수입업체', '소재지 및 제조국',
    '제조연월일, 소비기간 또는 품질유지기간', '포장단위별 용량(중량), 수량, 크기',
    '원재료 및 함량', '영양성분', '유전자변형식품 여부',
    '안전 주의사항', 'A/S 책임자&전화번호'
  ]
  let info22 = [//건강기능식품
    '제품명', '제조업체 및 수입업체', '소재지 및 제조국', '소비기간 및 보관방법',
    '포장단위별 용량(중량), 수량', '원재료 및 함량', '영양정보', '기능정보',
    '섭취방법 및 주의사항 및 부작용 가능성', '안전 주의사항', '유전자변형식품 여부', 'A/S 책임자&전화번호'
  ]
  let info23 = [//어린이제품
    '품명 및 모델명', 'KC 인증정보', '크기, 중량 또는 치수', '색상',
    '재질', '사용연령 또는 권장사용연령', '크기·체중의 한계', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '취급방법 및 취급 주의사항', '품질보증기준', 'A/S 책임자&전화번호'
  ]
  let info24 = [//악기
    '품명 및 모델명', '크기', '색상', '재질', '제품 구성', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '상품별 세부 사양', '품질보증기준', 'A/S 책임자&전화번호'
  ]
  let info25 = [//스포츠용품
    '품명 및 모델명', 'KC 인증정보', '크기 및 중량', '색상', '재질', '제품 구성', '동일모델의 출시년월',
    '제조자 및 수입자', '제조국', '상품별 세부 사양', '품질보증기준', 'A/S 책임자&전화번호'
  ]
  let info26 = [//서적
    '도서명', '저자 및 출판사', '크기(전자책은 파일 용량)', '쪽수', '제품 구성',
    '발행일', '목차 또는 책 소개'
  ]
  let info27 = [//호텔/펜션 예약
    '국가 또는 지역명', '숙소 형태', '등급, 객실 타입', '사용가능 인원, 인원 추가 비용',
    '부대시설 및 제공 서비스', '취소 규정(환불, 위약금 등)', '예약 담당 연락처'
  ]
  let info28 = [//여행패키지
    '여행사', '이용항공편', '여행기간 및 일정', '총 예정 인원, 출발 가능 인원', '숙박정보',
    '예행상품 가격', '선택경비 유무 및 세부 내용', '취소 규정(환불, 위약금 등)', '예약 담당 연락처'
  ]
  let info29 = [//항공권
    '요금조건, 왕복·편도 여부', '유효기간', '제한사항(출발일, 귀국일 변경가능 여부 등)', '티켓수령방법', '좌석종류',
    '가격에 포함되지 않은 내역 및 금액(유료할증료, 공항이용료 등)', '취소 규정(환불, 위약금 등)', '예약 담당 연락처'
  ]
  let info30 = [//자동차 대여 서비스(렌터카)
    '차종', '소유권 이전 조건', '추가 선택 시 비용(자차면책제도, 내비게이션 등)', '차량 반환 시 연료대금 정산 방법',
    '차량의 고장·훼손 시 소비자 책임', '예약 취소 또는 중도 해약 시 환불 기준', '소비자 상담 관련 전화번호'
  ]
  let info31 = [//물품대여 서비스(정수기, 비데, 공기청정기 등)
    '품명 및 모델명', '소유권 이전 조건', '유지보수 조건(점검·필터교환 주기, 추가 비용 등)',
    '상품의 고장·분실·훼손 시 소비자 책입', '중도 해약 시 환불 기준', '제품 사양(용량, 소비전력 등)', '소비자 상담 관련 전화번호'
  ]
  let info32 = [//물품대여 서비스(서적, 유아용품, 행사용품 등)
    '품명 및 모델명', '소유권 이전 조건', '상품의 고장·분실·훼손 시 소비자 책입',
    '중도 해약 시 환불 기준', '소비자 상담 관련 전화번호'
  ]
  let info33 = [//디지털 콘텐츠(음원, 게임, 인터넷강의 등)
    '품명 및 모델명', '소유권 이전 조건', '상품의 고장·분실·훼손 시 소비자 책입',
    '중도 해약 시 환불 기준', '소비자 상담 관련 전화번호'
  ]
  let info34 = [//상품권/쿠폰
    '발행자', '유효기간, 이용조건(유효기간 경과 시 보상 기준, 사용제한품목 및 기간 등)',
    '이용 가능 매장', '잔액 환급 조건', '소비자 상담 관련 전화번호'
  ]
  let info35 = [//모바일 쿠폰
    '발행자', '유효기간, 이용조건(유효기간 경과 시 보상 기준, 사용제한품목 및 기간 등)',
    '이용 가능 매장', '환불조건 및 방법', '소비자 상담 관련 전화번호'
  ]
  let info36 = [//영화·공연
    '주최 또는 기획(공연에 한함)', '주연(공연에 한함)', '관람등급', '상영·공연시간',
    '상영·공연장소', '예매 취소 조건', '취소·환불방법', '소비자 상담 관련 전화번호'
  ]
  let info37 = [//생활화학제품
    '품목 및 제품명', '용도 및 제형', '제조연월 및 유통기한', '중량·용량·매수·크기',
    '효과·효능', '수입자, 제조국 및 제조사', '어린이보호포장 대상제품 유무', '제품에 사용된 화학물질 명칭',
    '시용상 주위사항', '안전기준적합확인신고번호 또는 안전확인대상생활화학제품승인번호', '소비자 상담 관련 전화번호'
  ]
  let info38 = [//살생물제품
    '제품명 및 살생물제품유형', '유통기한', '중량 또는 용량 및 표준사용량', '효과·효능',
    '사용대상자 및 사용범위', '수입자, 제조국 및 제조사', '어린이보호포장 대상제품 유무',
    '살생물물질, 나노물질, 기타 화학물질의 명칭', '제품 유해정·위해성 표시',
    '사용방법 및 사용상 주의사항', '승인번호', '소비자 상담 관련 전화번호'
  ]
  let info39 = [//기타 용역
    '서비스 제공 사업자', '법에 의한 인증·허가증', '이용조건', '취소·중도해약·해지 조건 및 환불기준',
    '취소·환불방법', '소비자 상담 관련 전화번호'
  ]
  let info40 = [//기타 재화
    '품명 및 모델명', '법에 의한 인증·허가증', '제조국 또는 원산시',
    '제조자 및 수입자', 'A/S 책임자&전화번호 또는 소비자 상담 관련 전화번호'
  ]

  var result

  switch (type) {
    case 'info1':
      result = info1;
      break;

    case 'info2':
      result = info2;
      break;

    case 'info3':
      result = info3;
      break;
    
    case 'info4':
      result = info4;
      break;

    case 'info5':
      result = info5;
      break;

    case 'info6':
      result = info6;
      break;

    case 'info7':
      result = info7;
      break;

    case 'info8':
      result = info8;
      break;

    case 'info9':
      result = info9;
      break;

    case 'info10':
      result = info10;
      break;

    case 'info11':
      result = info11;
      break;

    case 'info12':
      result = info12;
      break;

    case 'info13':
      result = info13;
      break;

    case 'info14':
      result = info14;
      break;

    case 'info15':
      result = info15;
      break;

    case 'info16':
      result = info16;
      break;

    case 'info17':
      result = info17;
      break;

    case 'info18':
      result = info18;
      break;

    case 'info19_1':
      result = info19_1;
      break;

    case 'info19_2':
      result = info19_2;
      break;
        
    case 'info20_1':
      result = info20_1;
      break;
      
    case 'info20_2':
      result = info20_2;
      break;
    
    case 'info21':
      result = info21;
      break;
      
    case 'info22':
      result = info22;
      break;
      
    case 'info23':
      result = info23;
      break;
      
    case 'info24':
      result = info24;
      break;
      
    case 'info25':
      result = info25;
      break;
      
    case 'info26':
      result = info26;
      break;
      
    case 'info27':
      result = info27;
      break;
      
    case 'info28':
      result = info28;
      break;
      
    case 'info29':
      result = info29;
      break;
      
    case 'info30':
      result = info30;
      break;
      
    case 'info31':
      result = info31;
      break;
      
    case 'info32':
      result = info32;
      break;
      
    case 'info33':
      result = info33;
      break;

    case 'info34':
      result = info34;
      break;

    case 'info35':
      result = info35;
      break;

    case 'info36':
      result = info36;
      break;

    case 'info37':
      result = info37;
      break;

    case 'info38':
      result = info38;
      break;
      
    case 'info39':
      result = info39;
      break;
      
    case 'info40':
      result = info40;
      break;
  }

  return result
}